"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealBranches = exports.columns = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_2 = require("@nextui-org/react");
var main_1 = require("../../../../../../reducers/slices/main");
var add_branches_component_1 = __importDefault(require("../../components/add_branches_component"));
var current_page_items_1 = require("../../deal_and_voucher_helpers/current_page_items");
var table_top_bar_1 = require("../../../../../../components/table_top_bar");
var table_bottom_content_1 = require("../../../../../../components/table_bottom_content");
var tabel_cell_1 = require("../../../../../../components/tabel_cell");
var local_storage_names_1 = require("../../../../../../constants/local_storage_names");
var useMemoizedCallback_1 = require("../../../../../../helpers/useMemoizedCallback");
var INITIAL_VISIBLE_COLUMNS = ["display_name", "branch_number", "contact_number", "email", "offline"];
exports.columns = [
    { name: "Branch Name", uid: "display_name" },
    { name: "Branch Number", uid: "branch_number" },
    { name: "Contact Number", uid: "contact_number" },
    { name: "Email Address", uid: "email" },
    { name: "Status", uid: "offline" },
];
var DealBranches = function (props) {
    var _a, _b, _c, _d;
    var dispatch = (0, react_redux_1.useDispatch)();
    var values = props.values, setValues = props.setValues;
    var _e = (0, react_redux_1.useSelector)(function (state) { return state.userState; }), client_token = _e.client_token, user = _e.user;
    var _f = (0, react_1.useState)(1), currentBranchesPage = _f[0], setCurrentBranchesPage = _f[1];
    var _g = (0, react_1.useState)(5), branchRowsPerPage = _g[0], setBranchRowsPerPage = _g[1];
    var _h = (0, react_1.useState)([]), managerOf = _h[0], setManagerOf = _h[1];
    var _j = (0, react_1.useState)([]), branchesPerPage = _j[0], setBranchesPerPage = _j[1];
    var _k = (0, react_1.useState)(new Set([])), selectedKeys = _k[0], setSelectedKeys = _k[1];
    var tableColumnConfig = localStorage.getItem(local_storage_names_1.TABLE_COLUMN_CONFIG);
    var savedVisibleColumns = (_a = JSON.parse(tableColumnConfig)) !== null && _a !== void 0 ? _a : {};
    var initialVisibleColumns = (_b = savedVisibleColumns["branchesPerPage"]) !== null && _b !== void 0 ? _b : INITIAL_VISIBLE_COLUMNS;
    var _l = (0, react_1.useState)(new Set(initialVisibleColumns)), visibleColumns = _l[0], setVisibleColumns = _l[1];
    var _m = (0, react_1.useState)({
        column: "createdAt",
        direction: "ascending",
    }), sortDescriptor = _m[0], setSortDescriptor = _m[1];
    (0, react_1.useEffect)(function () {
        if ((user === null || user === void 0 ? void 0 : user.role) !== "ADMIN") {
            setManagerOf(user === null || user === void 0 ? void 0 : user.manager_of);
        }
    }, [client_token]);
    (0, react_1.useEffect)(function () {
        var branchesPerPage = (0, current_page_items_1.getCurrentPageBranches)(currentBranchesPage, branchRowsPerPage, values === null || values === void 0 ? void 0 : values.branches);
        setBranchesPerPage(branchesPerPage);
    }, [branchRowsPerPage, currentBranchesPage, values === null || values === void 0 ? void 0 : values.branches]);
    var filterSelectedKeys = (0, react_1.useMemo)(function () {
        var resultKeys = new Set();
        resultKeys = selectedKeys;
        return resultKeys;
    }, [selectedKeys, branchesPerPage]);
    var showAddBranchesModal = function () {
        return dispatch((0, main_1.setContentModal)({
            title: "Select Branches",
            content: (0, jsx_runtime_1.jsx)(add_branches_component_1.default, { onSave: handleBranchSave, onSelectAllChange: function () { } }),
        }));
    };
    var headerColumns = (0, react_1.useMemo)(function () {
        if (visibleColumns === "all")
            return exports.columns;
        return exports.columns
            .map(function (item) {
            if (item.uid === sortDescriptor.column) {
                return __assign(__assign({}, item), { sortDirection: sortDescriptor.direction });
            }
            return item;
        })
            .filter(function (column) { return Array.from(visibleColumns).includes(column.uid); });
    }, [visibleColumns, sortDescriptor]);
    var handleBranchSave = function (selectedBranchs) {
        var updatedBranches = __spreadArray([], values === null || values === void 0 ? void 0 : values.branches, true);
        selectedBranchs === null || selectedBranchs === void 0 ? void 0 : selectedBranchs.forEach(function (branch) {
            var _a;
            // Check if the branch is not already in availableProducts
            if (!((_a = values === null || values === void 0 ? void 0 : values.branches) === null || _a === void 0 ? void 0 : _a.some(function (existingBranch) { return (existingBranch === null || existingBranch === void 0 ? void 0 : existingBranch._id) === (branch === null || branch === void 0 ? void 0 : branch._id); }))) {
                updatedBranches === null || updatedBranches === void 0 ? void 0 : updatedBranches.push(branch);
            }
        });
        updateValues("branches", updatedBranches);
    };
    var updateValues = function (prop, value) {
        var _a;
        setValues(__assign(__assign({}, values), (_a = {}, _a[prop] = value, _a)));
    };
    var onSelectionChange = (0, useMemoizedCallback_1.useMemoizedCallback)(function (keys) {
        if (keys === "all") {
            setSelectedKeys(keys);
        }
        else if (keys.size === 0) {
            setSelectedKeys(new Set());
        }
        else {
            var resultKeys_1 = new Set();
            keys.forEach(function (v) {
                resultKeys_1.add(v);
            });
            var selectedValue = selectedKeys === "all" ? new Set(branchesPerPage === null || branchesPerPage === void 0 ? void 0 : branchesPerPage.map(function (item) { return String(item._id); })) : selectedKeys;
            selectedValue.forEach(function (v) {
                if (branchesPerPage === null || branchesPerPage === void 0 ? void 0 : branchesPerPage.some(function (item) { return String(item._id) === v; })) {
                    return;
                }
                resultKeys_1.add(v);
            });
            setSelectedKeys(new Set(resultKeys_1));
        }
    });
    var renderCellViews = function (cellValue) { return [
        {
            key: "display_name",
            content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: cellValue })),
        },
        {
            key: "branch_number",
            content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: cellValue })),
        },
        {
            key: "contact_number",
            content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: cellValue })),
        },
        {
            key: "email",
            content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: cellValue })),
        },
        {
            key: "offline",
            content: ((0, jsx_runtime_1.jsx)(react_2.Chip, __assign({ className: "text-nowrap text-small capitalize text-default-foreground", color: cellValue ? "danger" : "success", size: "sm", variant: "flat" }, { children: cellValue ? "Offline" : "Online" }))),
        },
    ]; };
    var totalPages = (0, react_1.useMemo)(function () {
        var _a, _b;
        return ((_a = values === null || values === void 0 ? void 0 : values.branches) === null || _a === void 0 ? void 0 : _a.length) ? Math.ceil(((_b = values === null || values === void 0 ? void 0 : values.branches) === null || _b === void 0 ? void 0 : _b.length) / 5) : 0;
    }, [(_c = values === null || values === void 0 ? void 0 : values.branches) === null || _c === void 0 ? void 0 : _c.length, 5]);
    var onBranchesPageChange = function (pageNumber) {
        setCurrentBranchesPage(pageNumber);
    };
    var processedBranches = branchesPerPage.map(function (item, index) { return (__assign(__assign({}, item), { fallbackKey: item._id || "fallback-key-".concat(index) })); });
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-row items-start gap-2 pt-4" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex-1" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: " flex col-span-2 items-center pb-2" }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, table_top_bar_1.tableTopBar)({
                            pageTitle: "Branches",
                            recordCount: (_d = values === null || values === void 0 ? void 0 : values.branches) === null || _d === void 0 ? void 0 : _d.length,
                            actionButtons: [
                                {
                                    label: "Add Branches",
                                    iconClassname: "solar:add-circle-bold",
                                    onClick: function () {
                                        showAddBranchesModal();
                                    },
                                },
                                {
                                    label: "Remove Branches",
                                    iconClassname: "solar:minus-circle-bold",
                                    onClick: function () {
                                        var _a;
                                        if (selectedKeys === "all") {
                                            if ((user === null || user === void 0 ? void 0 : user.role) === "BRANCH_MANAGER") {
                                                dispatch((0, main_1.setMessageModal)({
                                                    title: "Branch is required!",
                                                    messages: ["Branch is required for branch manager roles."],
                                                }));
                                                return;
                                            }
                                            updateValues("branches", []);
                                        }
                                        else {
                                            if ((user === null || user === void 0 ? void 0 : user.role) === "BRANCH_MANAGER") {
                                                dispatch((0, main_1.setMessageModal)({
                                                    title: "Branch is required!",
                                                    messages: ["Branch is required for branch manager roles."],
                                                }));
                                                return;
                                            }
                                            var updatedSelectedBranches = (_a = values === null || values === void 0 ? void 0 : values.branches) === null || _a === void 0 ? void 0 : _a.filter(function (branch) { return !selectedKeys.has(branch._id); });
                                            updateValues("branches", updatedSelectedBranches);
                                            onBranchesPageChange(1);
                                        }
                                    },
                                },
                            ].filter(Boolean),
                        }), (0, jsx_runtime_1.jsxs)(react_2.Table, __assign({ bottomContent: (0, table_bottom_content_1.tableBottomContent)({
                                filterSelectedKeys: filterSelectedKeys,
                                page: currentBranchesPage,
                                pages: totalPages,
                                filteredItems: branchesPerPage,
                                onPreviousPage: function () { return onBranchesPageChange(currentBranchesPage - 1); },
                                onNextPage: function () { return onBranchesPageChange(currentBranchesPage + 1); },
                                setPage: onBranchesPageChange,
                            }), bottomContentPlacement: "outside", classNames: {
                                td: "before:bg-transparent",
                            }, selectedKeys: filterSelectedKeys, onSelectionChange: onSelectionChange, selectionMode: "multiple", topContentPlacement: "outside" }, { children: [(0, jsx_runtime_1.jsx)(react_2.TableHeader, __assign({ columns: headerColumns }, { children: function (column) { return ((0, jsx_runtime_1.jsx)(react_2.TableColumn, __assign({ align: column.uid === "actions" ? "end" : "start", className: (0, react_2.cn)([column.uid === "actions" ? "flex items-center justify-end px-[20px]" : ""]) }, { children: column.name }), column.uid)); } })), (0, jsx_runtime_1.jsx)(react_2.TableBody, __assign({ isLoading: false, emptyContent: "This table is empty.", items: processedBranches, loadingContent: (0, jsx_runtime_1.jsx)(react_2.Spinner, {}) }, { children: function (item) {
                                        return ((0, jsx_runtime_1.jsx)(react_2.TableRow, { children: function (columnKey) { return ((0, jsx_runtime_1.jsx)(react_2.TableCell, { children: (0, jsx_runtime_1.jsx)(tabel_cell_1.TableCellComponent, { columnRecord: item, columnKey: columnKey, renderCellViews: renderCellViews }) })); } }, item._id || item.fallbackKey));
                                    } }))] }))] })] })) })));
};
exports.DealBranches = DealBranches;
